import BaseOption from "@/app/components/common-filter-builder/common-filters-components/base-checkbox/BaseOption";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { Controller, FieldValues, UseFormReturn } from "react-hook-form";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  fieldName: string;
  option: { id: number | string; value: string };
  isRequired: boolean;
  onOptionChange?: (option_id: number | string) => void;
  disabled?: boolean;
}

const RadioHook: React.FC<Props> = ({
  form,
  fieldName,
  option,
  isRequired,
  onOptionChange = null,
  disabled,
}) => {
  const t = useTranslation();
  return (
    <div>
      <Controller
        name={fieldName}
        control={form.control}
        rules={{
          required: { value: isRequired, message: t.this_field_is_required },
        }}
        render={({ field: { value, onChange, ref } }) => (
          <BaseOption
            label={option.value}
            is_multi_select={false}
            toggleOption={() => {
              onChange(option.id);
              onOptionChange && onOptionChange(option.id);
            }}
            selected={value === option.id}
            optionRef={ref}
            value={value}
            disabled={disabled}
          />
        )}
      />
    </div>
  );
};

export default RadioHook;
